  <div>
    <nz-upload *ngIf="showUploader" nzType="drag" [nzBeforeUpload]="handleBeforeUpload">
      <p class="ant-upload-drag-icon">
        <nz-icon nzType="inbox" />
      </p>
      <p class="ant-upload-text">Click or drag file to this area to upload</p>
      <p class="ant-upload-hint">
        Support PDF only
      </p>
    </nz-upload>

    <div class="zoomBtns" *ngIf="!showUploader">
      <button nz-button [nzType]="drawingMode ? 'primary' : 'default'" (click)="setAction()">Draw Fields</button>
      <button nz-button [nzType]="editMode ? 'primary' : 'default'" (click)="editAction()">Delete Fields</button>
    </div>

    <div *ngIf="!showUploader"  id="pdf-container" class="centeredPdf">

    </div>
    <div *ngIf="!showUploader" class="saveCont">

      <form [formGroup]="docForm">
    
        <nz-form-item>
          <nz-form-label nzRequired>Document Name</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="name" placeholder="Document name here" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item *ngIf="modalData.viewAll">
          <nz-form-label>Apply to</nz-form-label>
          <nz-form-control>
            <nz-select formControlName="type">
              <nz-option nzValue="distributor" nzLabel="Distributor"></nz-option>
              <nz-option nzValue="company" nzLabel="Company"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item *ngIf="docForm.get('type')?.value == 'distributor'">
          <nz-form-label>Distributor</nz-form-label>
          <nz-form-control>
            <nz-select formControlName="distributors">
              <nz-option *ngFor="let d of modalData.distributors" [nzValue]="d.id" [nzLabel]="d.name"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item *ngIf="docForm.get('type')?.value === 'company' || (modalData.viewCompanies && !modalData.viewAll)">
          <nz-form-label>Company</nz-form-label>
          <nz-form-control>
            <nz-select formControlName="companies">
              <nz-option *ngFor="let c of modalData.companies" [nzValue]="c.id" [nzLabel]="c.name"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
  
      </form>

      <button nz-button nzType="primary" [nzLoading]="loadingDoc" (click)="saveTemplate()">Save</button>
    </div>
  </div>
  <nz-modal [(nzVisible)]="fieldModal" nzBordered nzTitle="Add Field Details" (nzOnCancel)="closeFieldLabelModal()" (nzOnOk)="submitFieldLabel()">
    <ng-container *nzModalContent>
      <form [formGroup]="fieldForm">
        <nz-form-item>
          <nz-form-label>Input Type</nz-form-label>
          <nz-form-control>
            <nz-select formControlName="type" placeholder="Select input type">
              <nz-option nzValue="signature" nzLabel="Signature"></nz-option>
              <nz-option nzValue="text" nzLabel="Text"></nz-option>
              <nz-option nzValue="date" nzLabel="Date"></nz-option>
              <nz-option nzValue="checkbox" nzLabel="Checkbox"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
    
        <nz-form-item>
          <nz-form-label>Field Name</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="name" placeholder="Unique field key" />
          </nz-form-control>
        </nz-form-item>
    
        <nz-form-item>
          <nz-form-label>Placeholder</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="placeholder" placeholder="Placeholder text" />
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-container>
  </nz-modal>
